/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { LaunchDarklyError } from "./launchdarklyerror.js";

export type NotFoundErrorRepData = {
  /**
   * Specific error code encountered
   */
  code: string;
  /**
   * Description of the error
   */
  message: string;
};

export class NotFoundErrorRep extends LaunchDarklyError {
  /**
   * Specific error code encountered
   */
  code: string;

  /** The original data that was passed to this error instance. */
  data$: NotFoundErrorRepData;

  constructor(
    err: NotFoundErrorRepData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;
    this.code = err.code;

    this.name = "NotFoundErrorRep";
  }
}

/** @internal */
export const NotFoundErrorRep$inboundSchema: z.ZodType<
  NotFoundErrorRep,
  z.ZodTypeDef,
  unknown
> = z.object({
  code: z.string(),
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new NotFoundErrorRep(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type NotFoundErrorRep$Outbound = {
  code: string;
  message: string;
};

/** @internal */
export const NotFoundErrorRep$outboundSchema: z.ZodType<
  NotFoundErrorRep$Outbound,
  z.ZodTypeDef,
  NotFoundErrorRep
> = z.instanceof(NotFoundErrorRep)
  .transform(v => v.data$)
  .pipe(z.object({
    code: z.string(),
    message: z.string(),
  }));
